import { BASE_URL } from './Config.js';

export class ImportService {
  
  importTVA = async (file) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${BASE_URL}/import/tva`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Erreur lors de l\'import TVA');
      }
      return await response.text();
    } catch (error) {
      console.error('Error importing TVA:', error);
      throw error;
    }
  };

  importProducts = async (file) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${BASE_URL}/import/products`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'Erreur lors de l\'import des produits');
      }
      return await response.text();
    } catch (error) {
      console.error('Error importing products:', error);
      throw error;
    }
  };
}